import React from "react";
import ProductsList from "./ProductsList/ProductsList";

export default function ConstructorAdmon() {
  return (
    <div className="pt-8 px-4 pb-4 sm:pt-6 sm:px-6 sm:pb-6 lg:pt-8 lg:px-8 lg:pb-8">
      <ProductsList />
    </div>
  );
}
